import { useTranslation } from 'react-i18next';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function Contactos() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-orange-500 to-orange-600 py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            {t('contactTitle')}
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            {t('contactSubtitle')}
          </p>
        </div>
      </section>

      {/* Contact Information & Form */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-8">
                  {currentLang === 'pt' ? 'Informações de Contacto' : currentLang === 'es' ? 'Información de Contacto' : 'Contact Information'}
                </h2>
              </div>

              <div className="bg-white rounded-2xl shadow-lg p-8 space-y-6">
                <div className="flex items-start">
                  <div className="w-14 h-14 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-white text-2xl"></i>
                  </div>
                  <div className="ml-5">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">{t('phone')}</h3>
                    <a href="tel:+351937545000" className="text-orange-500 hover:text-orange-600 text-xl font-medium cursor-pointer">
                      +351 937 545 000
                    </a>
                    <p className="text-xs text-gray-500 mt-1">(Custo de uma chamada para a rede móvel nacional)</p>
                  </div>
                </div>

                <div className="border-t border-gray-100 pt-6">
                  <div className="flex items-start">
                    <div className="w-14 h-14 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-white text-2xl"></i>
                    </div>
                    <div className="ml-5">
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">{t('email')}</h3>
                      <a href="mailto:geral@faroways.com" className="text-orange-500 hover:text-orange-600 text-xl font-medium cursor-pointer">
                        geral@faroways.com
                      </a>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-100 pt-6">
                  <div className="flex items-start">
                    <div className="w-14 h-14 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-white text-2xl"></i>
                    </div>
                    <div className="ml-5">
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">{t('address')}</h3>
                      <p className="text-gray-600 text-base leading-relaxed">
                        Rua João de Deus, 28C<br />
                        8000-368 Faro, Portugal
                      </p>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-100 pt-6">
                  <div className="flex items-start">
                    <div className="w-14 h-14 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-white text-2xl"></i>
                    </div>
                    <div className="ml-5">
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">{t('schedule')}</h3>
                      <p className="text-gray-600 text-base whitespace-pre-line">{t('scheduleText')}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Company Info */}
              <div className="bg-orange-50 rounded-xl p-6">
                <p className="text-sm text-gray-700 leading-relaxed">
                  <strong className="text-orange-600">FARWAYS</strong> - Marca registada de Alves e Frade, Lda.<br />
                  <strong>NIPC:</strong> 505413850 | <strong>RNAVT:</strong> 8586
                </p>
              </div>

              {/* Legal Links */}
              <div className="bg-white rounded-xl shadow-md p-6 space-y-4">
                <a 
                  href="https://www.livroreclamacoes.pt/Inicio/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-700 hover:text-orange-500 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 bg-gray-100 group-hover:bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors">
                    <i className="ri-file-list-3-line text-2xl text-gray-600 group-hover:text-orange-500"></i>
                  </div>
                  <div className="ml-4">
                    <p className="font-semibold text-base">
                      {currentLang === 'pt' ? 'Livro de Reclamações Online' : currentLang === 'es' ? 'Libro de Reclamaciones Online' : 'Online Complaints Book'}
                    </p>
                    <p className="text-sm text-gray-500">www.livroreclamacoes.pt</p>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-xl text-gray-400 group-hover:text-orange-500"></i>
                </a>
                
                <div className="border-t border-gray-100"></div>

                <a 
                  href="https://consumoalgarve.pt/index.php/pt/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-700 hover:text-orange-500 transition-colors cursor-pointer group"
                >
                  <div className="w-12 h-12 bg-gray-100 group-hover:bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors">
                    <i className="ri-scales-3-line text-2xl text-gray-600 group-hover:text-orange-500"></i>
                  </div>
                  <div className="ml-4">
                    <p className="font-semibold text-base">
                      {currentLang === 'pt' ? 'Centro de Arbitragem de Consumo do Algarve' : currentLang === 'es' ? 'Centro de Arbitraje de Consumo del Algarve' : 'Algarve Consumer Arbitration Center'}
                    </p>
                    <p className="text-sm text-gray-500">consumoalgarve.pt</p>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-xl text-gray-400 group-hover:text-orange-500"></i>
                </a>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-10">
              <h2 className="text-3xl font-bold text-gray-900 mb-2">
                {t('formTitle')}
              </h2>
              <p className="text-gray-600 mb-8">
                {currentLang === 'pt' ? 'Preencha o formulário abaixo e entraremos em contacto consigo brevemente.' : currentLang === 'es' ? 'Complete el formulario a continuación y nos pondremos en contacto con usted en breve.' : 'Fill out the form below and we will contact you shortly.'}
              </p>

              <form 
                className="space-y-6" 
                data-readdy-form
                action="https://readdy.ai/api/form/d46rnibq5e24j8uscv3g"
                method="POST"
                onSubmit={(e) => {
                  e.preventDefault();
                  const formData = new FormData(e.target as HTMLFormElement);
                  fetch('https://readdy.ai/api/form/d46rnibq5e24j8uscv3g', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(formData as any).toString()
                  }).then(() => {
                    alert(t('successMessage'));
                    (e.target as HTMLFormElement).reset();
                  }).catch(() => {
                    alert(t('errorMessage'));
                  });
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      {t('nameLabel')}
                    </label>
                    <input
                      type="text"
                      name="nome"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm transition-all"
                      placeholder={t('namePlaceholder')}
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      {t('email')}
                    </label>
                    <input
                      type="email"
                      name="email"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm transition-all"
                      placeholder={t('emailPlaceholder')}
                      required
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    {t('phoneLabel')}
                  </label>
                  <input
                    type="tel"
                    name="telefone"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm transition-all"
                    placeholder={t('phonePlaceholder')}
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    {t('subjectLabel')}
                  </label>
                  <input
                    type="text"
                    name="assunto"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm transition-all"
                    placeholder={t('subjectPlaceholder')}
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    {t('messageLabel')}
                  </label>
                  <textarea
                    rows={6}
                    name="mensagem"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm transition-all resize-none"
                    placeholder={t('messagePlaceholder')}
                    maxLength={500}
                    required
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">
                    {currentLang === 'pt' ? 'Máximo 500 caracteres' : currentLang === 'es' ? 'Máximo 500 caracteres' : 'Maximum 500 characters'}
                  </p>
                </div>

                <button
                  type="submit"
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white py-4 rounded-lg font-semibold transition-colors whitespace-nowrap shadow-lg hover:shadow-xl"
                >
                  {t('submitButton')}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">
              {currentLang === 'pt' ? 'Como Chegar' : currentLang === 'es' ? 'Cómo Llegar' : 'How to Get Here'}
            </h2>
            <p className="text-gray-600">
              {currentLang === 'pt' ? 'Encontre-nos facilmente no centro de Faro' : currentLang === 'es' ? 'Encuéntrenos fácilmente en el centro de Faro' : 'Find us easily in the center of Faro'}
            </p>
          </div>
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3154.123456789!2d-7.9304!3d37.0194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sFaro%20Airport!5e0!3m2!1sen!2spt!4v1234567890"
              width="100%"
              height="500"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização FARWAYS VIAGENS"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
